import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { Select as SelectAtom, SelectProps } from 'components/atoms/select';
import { StatusPickerOption } from 'components/atoms/status-picker/option';

const Option = styled(StatusPickerOption)`
  padding: var(--spacing-01) var(--spacing-03);
`;

const Select = styled(SelectAtom)`
  .ozone-select__value-container--has-value {
    .ozone-select__option {
      padding: 0;
    }
    input {
      width: 0;
    }
  }
`;

export const StatusSelect = forwardRef<any, SelectProps>(
  ({ components, ...props }, ref) => {
    return (
      <Select
        ref={ref}
        components={{
          ...components,
          Option,
          SingleValue: StatusPickerOption,
          Input: null,
        }}
        {...props}
      />
    );
  },
);
